import { render, staticRenderFns } from "./SportMembersList.vue?vue&type=template&id=561d70a2&scoped=true"
import script from "./SportMembersList.vue?vue&type=script&lang=js"
export * from "./SportMembersList.vue?vue&type=script&lang=js"
import style0 from "./SportMembersList.vue?vue&type=style&index=0&id=561d70a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d70a2",
  null
  
)

export default component.exports